import type { Move } from 'chessboard/model/move/types';

/**
 * Try moving backward
 */
export function tryMovingBackward(params: Move.BackwardWithContext) {
  const { selectContinuationMoves = false, steps = 1, context } = params;
  const { mutateGame, game } = context;

  // @ts-ignore
  const startBughouseIndex = game.siblingGame ? game.curBughouseMove() : null;
  const startIds = game.ids();

  const firstStepData = mutateGame(function callMethod() {
    game.moveBackward(selectContinuationMoves);
  });

  let success = firstStepData?.plyDiff === -1;

  if (steps > 1 && success) {
    // starting from index 1 as first step has already been consumed
    for (let i = 1; i < steps; i++) {
      success = game.moveBackward(selectContinuationMoves);

      if (!success) {
        break;
      }
    }
  }

  const endIds = game.ids();
  // @ts-ignore
  const endBughouseIndex = game.siblingGame ? game.curBughouseMove() : null;

  if (startBughouseIndex !== null) {
    // @ts-ignore
    game.selectBughouseMove(startBughouseIndex);
  } else {
    game.selectPosition(startIds.move, startIds.line);
  }

  return {
    firstStepData,
    startIds,
    startBughouseIndex,
    endBughouseIndex,
    endIds,
    success,
  };
}
